import Navbar from "./Navbar";
import style from './Crew.module.css'
import React,{useState} from 'react'
import Anousheh from './crew/image-anousheh-ansari.png'
import Mark from './crew/image-mark-shuttleworth.png'
import Victor from './crew/image-victor-glover.png'
import Douglas from './crew/image-douglas-hurley.png'

const Crew = () => {
const [selectedCrew, setSelectedCrew] = useState(0)
const crew = [
  
    {
      "name": "Douglas Hurley",
 
        "images": Douglas,
    
      "role": "Commander",
      "bio": "Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA astronaut. He launched into space for the third time as commander of Crew Dragon Demo-2."
    },
    {
      "name": "Mark Shuttleworth",
      "images": Mark,
      "role": "Mission Specialist",
      "bio": "Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space tourist."
    },
    {
      "name": "Victor Glover",
      "images": Victor,
      "role": "Pilot",
      "bio": "Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. Glover is a commander in the U.S. Navy where he pilots an F/A-18.He was a crew member of Expedition 64, and served as a station systems flight engineer."
    },
    {
      "name": "Anousheh Ansari",
      "images": Anousheh,
      "role": "Flight Engineer",
      "bio": "Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first Iranian in space."
    }
 
]
    return (
        <div className={style.Crew} >
          <Navbar />
          {/* Main Content */}
          <main className={style.mainCrew}>
          <h1>
                    <span>02</span> MEET YOUR CREW
                </h1>
                <div className={style.CrewDetails}>
        {/* Crew Info */}
         <div className={style.CrewInfo}>
          {/* Crew Details */}
                <h3>{crew[selectedCrew].role} </h3>
                <h2>{crew[selectedCrew].name} </h2>
                <p className={style.description}>{crew[selectedCrew].bio } </p>
                <div className={style.Crewtabs}> 
          {crew.map((crewMember, index) => (
            <button 
            key={crewMember.name} className={index === selectedCrew ? style.activeTabCrew : style.tabCrew} onClick={() => setSelectedCrew(index)}> 
            </button>
          ))}
          </div>
              
              </div>
              {/* CrewImage */}
        <div>
          <img className={style.crewImg} src={crew[selectedCrew].images}  alt={crew[selectedCrew].name} />
        </div>
       </div>
          </main>
        </div>
    );
}
export default Crew